import { Box, Button, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { Link } from "react-router-dom";
import { ROUTE_HOME } from "../constants";

export const PageNotFound = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        minHeight: "100vh",
        backgroundColor: grey[200],
        rowGap: "1em",
      }}
    >
      <Typography variant="h1">404</Typography>
      <Typography variant="h6">Die Seite existiert nicht.</Typography>
      <Link to={ROUTE_HOME}>
        <Button variant="outlined">Zur Hauptseite</Button>
      </Link>
    </Box>
  );
};
